import React from 'react';
import { useStaticQuery } from 'gatsby';
import Wrapper from '@components/wrapper.styled';
import LinkComponent from '@components/link';
import { StyledFooter, Content, Legal, Attribution } from './footer.styled';
var Footer = function Footer() {
    var _prismicMainPageSchem;
    var _useStaticQuery = useStaticQuery("265957578"), prismicMainPageSchema = _useStaticQuery.prismicMainPageSchema;
    var currentYear = new Date().getFullYear();
    var copyText = "\xA9 " + currentYear + " " + ((prismicMainPageSchema === null || prismicMainPageSchema === void 0 ? void 0 : (_prismicMainPageSchem = prismicMainPageSchema.data) === null || _prismicMainPageSchem === void 0 ? void 0 : _prismicMainPageSchem.legal_brand_name) || 'Supervillain');
    return /*#__PURE__*/ React.createElement(StyledFooter, null, /*#__PURE__*/ React.createElement(Wrapper, null, /*#__PURE__*/ React.createElement(Content, null, /*#__PURE__*/ React.createElement(Legal, null, copyText), /*#__PURE__*/ React.createElement(Attribution, null, "Made by", ' ', /*#__PURE__*/ React.createElement(LinkComponent, {
        type: "text",
        url: "https://www.supervillain.group/",
        title: "Supervillain"
    })))));
};
export default Footer;
